/*
 * Date: 2020-08-03 11:53:37
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-03 12:15:12
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
export default {
  excludeComponentTypes: [
    'FORM_WIDGET_TABLE',
    'FORM_WIDGET_SPACE',
    'FORM_WIDGET_FILE',
    'FORM_STATIC_TEXT',
    'FORM_STATIC_IMG',
    'FORM_WIDGET_SPLIT'
  ],
  componentValueTypes: {
    TEXT_INPUT: [
      'FORM_TEXT_INPUT',
      'FORM_TEXTAREA_INPUT',
      'FORM_PHONE_INPUT',
      'FORM_EMAIL_INPUT',
      'FORM_IDCARD_INPUT',
      'FORM_DOCUMENT_NUMBER',
      'FORM_RICH_TEXT',
      'FORM_STATIC_TEXT',
      'FORM_WIDGET_CALC'
    ],
    SELECT_INPUT: ['FORM_SELECT_INPUT', 'FORM_RADIO_INPUT', 'FORM_CHECKBOX_INPUT'],
    PEOPLE_SELECT: ['FORM_PEOPLE_SELECT'],
    DEPARTMENT_SELECT: ['FORM_DEPARTMENT_SELECT'],
    NUMBER_INPUT: ['FORM_NUMBER_INPUT', 'FORM_MONEY_INPUT'],
    DATE_SELECT: ['FORM_DATEPICK_INPUT'],
    LOV_INPUT: ['FORM_DATA_SELECTOR']
  },
  judgeTypes: {
    TEXT_INPUT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '包含', value: 'in' },
      { label: '不包含', value: 'notIn' },
      { label: '开头为', value: 'startWith' },
      { label: '结尾为', value: 'endWith' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    DATE_SELECT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '早于', value: 'before' },
      { label: '晚于', value: 'after' },
      { label: '在范围内', value: 'in' },
      { label: '不在范围内', value: 'notIn' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    SELECT_INPUT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '包含', value: 'in' },
      { label: '不包含', value: 'notIn' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    PEOPLE_SELECT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '包含', value: 'in' },
      { label: '不包含', value: 'notIn' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    DEPARTMENT_SELECT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '包含', value: 'in' },
      { label: '不包含', value: 'notIn' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    NUMBER_INPUT: [
      { label: '=', value: 'eq' },
      { label: '≠', value: 'notEq' },
      { label: '>', value: 'gt' },
      { label: '≥', value: 'ge' },
      { label: '<', value: 'lt' },
      { label: '≤', value: 'le' },
      { label: '在范围内', value: 'in' },
      { label: '不在范围内', value: 'notIn' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ],
    LOV_INPUT: [
      { label: '是', value: 'eq' },
      { label: '不是', value: 'notEq' },
      { label: '为空', value: 'isNull' },
      { label: '不为空', value: 'isNotNull' }
    ]
  }
}
